import React from 'react';
import { motion } from 'framer-motion';

const NameDisplay: React.FC = () => {
  return (
    <motion.span
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="inline-block leading-none"
    >
      <span className="relative">
        <span className="text-3xl font-semibold tracking-[-0.04em] text-slate-900 dark:text-slate-200 sm:text-4xl lg:text-5xl leading-none">
          Shivansh Mane
        </span>
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-cosmic-aurora-emerald/10 via-cosmic-aurora-sapphire/10 to-cosmic-aurora-amethyst/10 blur-xl"
          animate={{
            opacity: [0.15, 0.28, 0.15],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </span>
    </motion.span>
  );
};

export default NameDisplay;
